import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=5ed64a5e&"
import script from "./Users.vue?vue&type=script&lang=js&"
export * from "./Users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Users.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ed64a5e')) {
      api.createRecord('5ed64a5e', component.options)
    } else {
      api.reload('5ed64a5e', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=5ed64a5e&", function () {
      api.rerender('5ed64a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/Users.vue"
export default component.exports